module.exports = __webpack_public_path__ + "static/map-532783b38ccd0f288b05db93fa3b5b79.png";